import Loadable from '../../components/loadable';

const PosSales = Loadable({
  loader: () => import('../../pages/pos/sales/index'),
  type: 'block',
});

angular.module('gym').value('PosSales', PosSales);

const PosSalesListFiltersModal = Loadable({
  loader: () => import('../../pages/pos/sales/pos_sales_list_filters_modal'),
  type: 'modal',
});

angular.module('gym').value('PosSalesListFiltersModal', PosSalesListFiltersModal);
